import Image from "next/image";
import ActiveTagCard from "./ActiveTagCard";
import SectionHeading from "../SectionHeading";
import { MOBILE_APP_LINK } from "@/utils/constants/mobileAppLink";

function ActiveTag() {
  return (
    <div className="relative overflow-hidden text-pet-tag pb-[6.75rem] mt-[3.125rem] lg:mt-0">
      <SectionHeading
        title="How to Active the Tag?"
        className="mb-[3.125rem]"
      />
      <div className="max-w-[68.125rem] justify-between mx-auto flex flex-col gap-[2rem] md:gap-0 items-center md:items-start md:flex-row">
        <div className="relative">
          <div className="absolute hidden md:block -top-[4rem] -left-[8rem] w-[500px] h-[500px]">
            <Image src="/assets/pet-tag/active-tag-bg-1.png" fill alt="" />
          </div>

          <ActiveTagCard
            imageSrc="/assets/pet-tag/active-tag-1.svg"
            title="Register Your Pet on AmarPet"
          >
            <p className="mb-[2rem] text-xl text-center leading-[2rem]">
              Download the&nbsp;
              <span className="font-bold uppercase">FREE</span>
              &nbsp;AmarPet app, create an account, and fill in your pet’s
              profile with essential details.
            </p>
            <a
              href={MOBILE_APP_LINK.play_store}
              target="_blank"
              rel="noreferrer"
            >
              <Image
                src="/assets/pet-tag/tag-google-play.svg"
                width={174}
                height={58}
                quality={30}
                alt="Get it on google play"
                className="mb-[0.5rem]"
              />
            </a>

            <a
              href={MOBILE_APP_LINK.app_store}
              target="_blank"
              rel="noreferrer"
            >
              <Image
                src="/assets/pet-tag/tag-app-store.svg"
                width={174}
                height={58}
                quality={30}
                alt="Download on the app store"
              />
            </a>
          </ActiveTagCard>
        </div>

        <div className="relative">
          <div className="absolute hidden md:block -top-[4rem] -left-[7.5rem] w-[500px] h-[500px]">
            <Image src="/assets/pet-tag/active-tag-bg-2.png" fill alt="" />
          </div>

          <ActiveTagCard
            imageSrc="/assets/pet-tag/active-tag-2.svg"
            title="Activate Your AmarPet Tag"
          >
            <p className="text-xl text-center leading-[2rem]">
              In the app, go to the ‘My Pet’ tab and select ‘Add Pet Tag.’ Scan
              the QR code or manually enter the tag’s ID and activation code to
              link it to your pet’s profile.
            </p>
          </ActiveTagCard>
        </div>

        <div className="relative">
          <div className="absolute hidden md:block -top-[4rem] -left-[6rem] w-[500px] h-[500px]">
            <Image src="/assets/pet-tag/active-tag-bg-3.png" fill alt="" />
          </div>
          <ActiveTagCard
            imageSrc="/assets/pet-tag/active-tag-3.svg"
            title="Your Pet is Now Protected"
          >
            <p className="text-xl text-center leading-[2rem]">
              With the tag activated, your pet’s safety is enhanced. Anyone who
              finds your pet can scan the tag to access your contact information
              and help bring them home.
            </p>
          </ActiveTagCard>
        </div>
      </div>
    </div>
  );
}

export default ActiveTag;
